<template>
  <b-modal
    id="modal-multi-3"
    size=""
    title="Confirmación"
    ok-only
    ok-title="Accept"
    v-model="$store.state.someVariables.showConfirmacionFinalizarEtapa"
  >
    <b-card-text class="my-1">
      Ingrese un nombre para sus Slots, este nombre le debe permitir reconocer
      su configuración
      <br />
      Ejemplo Slots para horarios de Maxima primera y segunda
      <br />
      Recuerde que una vez guardada la configuración de Slots, esta no se podrá
      modificar
    </b-card-text>
    <div class="form-label-group mt-3">
      <b-form-input
        id="floating-institucion"
        placeholder="descripción breve(ejemplo: Slots maxima primera y segunda) *"
        v-model="nombreSlotsUs"
        style="text-transform: uppercase"
      />
      <label for="floating-institucion">Nombre o descripción *</label>
    </div>
    <template #modal-footer>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="outline-primary"
        class="float-right mr-1 "
        @click="close"
      >
        Cancelar
      </b-button>
      <b-button
        v-if="!showLoading"
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        class="float-right"
        @click="saveSlots"
      >
        Guardar
      </b-button>
      <div v-if="showLoading" class="text-center mt-1">
        <b-spinner variant="primary" label="Text Centered" />
      </div>
    </template>
  </b-modal>
</template>

<script>
import {
  BModal,
  BCardText,
  BButton,
  BSpinner,
  BFormInput,
  // xxx,
  // xxxx,
  // sss,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import { computed } from '@vue/composition-api'
// import { ref } from '@vue/composition-api'
// import apiCall from '../../utils/apiCall'
// import {
//   URL,
//   //   USER,
//   //   ROLES,
//   //   ESTADO_JUGADOR,
//   //   INSERT_DATA_PLAYER,
//   //   INSERT_DATA_HISTORY_PLAYER,
//   //   UPDATE_DATA_PLAYER,
// } from '../../utils/variables'

export default {
  components: {
    BModal,
    BCardText,
    BButton,
    BSpinner,
    BFormInput,
  },
  directives: {
    // 'b-popover': VBPopover,
    // heightFade,
    Ripple,
  },
  props: {
    showLoading: Boolean,
    nombreSlots: String,
  },
  setup(props, { emit }) {
    const nombreSlotsUs = computed({
      get: () => props.nombreSlots,
      set: value => {
        // props.isManualProp = value
        emit('changeName', value)
      },
    })
    function close() {
      store.commit('someVariables/UPDATE_SHOW_SLOTS', false)
    }
    function saveSlots() {
      if (
        props.nombreSlots === '' ||
        props.nombreSlots === undefined ||
        props.nombreSlots === null
      ) {
        emit('error', 'Error, existen campos vacios')
      } else {
        emit('saveSlots', { name: props.nombreSlots })
      }
    }

    return {
      close,
      saveSlots,
      // nombreSlots,
      nombreSlotsUs,
    }
  },
}
</script>
